module.exports = __webpack_public_path__ + "static/media/digital.d3c05091.svg";